import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class GroupSearchParams extends SearchParamsBase {
  initialize() {
    this.GroupIdOrName = '';
    this.GroupDescription = '';
    this.IsActive = '';
    this.GroupParentId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'GroupIdOrName', label: 'Group ID or Name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'GroupDescription', label: 'Group Description', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'IsActive', label: 'Is Active?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'GroupSearchParams';

  static ConvertToJSON(originalSearchItem) {
    const correctedSearchItem = { ...originalSearchItem };

    for (const prop in correctedSearchItem) {
      correctedSearchItem[prop] = correctedSearchItem[prop].toString();
    }
    return JSON.stringify(correctedSearchItem);
  }
}
